import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {cn} from '@/helpers/shadcn/utils';
import {useIntl} from 'react-intl';
import {PageHeader} from '@/components/molecules';

const PageContent = ({
  title,
  pageHeaderContent,
  pageContentWrapperClassName,
  className,
  children,
  ...props
}) => {
  const {formatMessage} = useIntl();

  const formattedTitle = useMemo(
    () => (title ? formatMessage({id: title}) : ''),
    [title, formatMessage]
  );

  return (
    <div
      className={cn('flex flex-col text-base', pageContentWrapperClassName)}
      {...props}>
      {(title || pageHeaderContent) && (
        <PageHeader title={formattedTitle} className=''>
          {pageHeaderContent}
        </PageHeader>
      )}
      <div
        className={cn(
          'shadow mb-3 mt-2 flex w-full flex-col rounded-lg border-none bg-layer-01 p-6',
          className
        )}
        data-cy='page-content'>
        {children}
      </div>
    </div>
  );
};

PageContent.propTypes = {
  title: PropTypes.string,
  pageHeaderContent: PropTypes.node,
  pageContentWrapperClassName: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

export default React.memo(PageContent);
